var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.resales-not-shooting'),"name":"resalesNotShooting","url":_vm.$listRoutes.resalesWaitingShooting,"table":_vm.resalesNotShooting,"filters":_vm.resalesNotShootingFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }